// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__NylLA","selects":"Documents_selects__3GW8J"};